// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-resource[data-v-c5864abe]{padding:2rem 1rem}", "",{"version":3,"sources":["webpack://./resources/js/Components/Canvas/AddCanvasElement/AddResourceTabContent.vue"],"names":[],"mappings":"AAAA,+BAAc,iBAEd","sourcesContent":[".add-resource{padding:2rem 1rem}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
